module.exports = __webpack_public_path__ + "media/Voce.ec517a3c.mp3";